import * as types from './actionTypes';
import {FUNDING_APP_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {generateURL} from '../api/urlHelper';

const newBase = FUNDING_APP_BASE_URL().replace('partner_api/v1/', 'api/v2/');

export function selectPartner(data) {
  return {type: types.SELECT_PARTNER, partner: data};
}

export function receivePartners(json) {
  const data = json || {};
  return {type: types.RECEIVE_PARTNERS, options: data};
}

export function receivePartner(json) {
  const data = json || {};
  return { type: types.RECEIVE_PARTNER, partner: data.partner };
}

export function fetchPartner(id) {
  return dispatch => {
    return authenticatedFetch(partnerURL(id), {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(json => dispatch(receivePartner(json)));
  };
}


export function fetchPartners() {
  return dispatch => {
    return authenticatedFetch(dropdownPartnersURL(), {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => dispatch(receivePartners(json)));
  };
}

export function dropdownPartnersURL(params) {
  let url = `${newBase}dropdown_partners`;
  return generateURL(url, params);
}

export function partnerURL(id) {
  return `${newBase}partners/${id}`;
}